export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14499.115d3f4a.jpg";